<template>
  <div ui-view>
    <div class="row" v-if="$root.features.newProjectFromDashboard">
      <div class="col-lg-12 col-md-12 col-xs-12 text-center">
        <button type="button" class="btn btn-info" v-on:click="createProject"><i class="fa fa-plus"></i> {{ $t('Projects.add') }}</button>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12 col-xs-12">
        <card
          :title="$t('Orders.currentOrders')"
          :refresh="loadOrders"
          :loader="orderLoader"
          :alert="orderAlert"
          :alert-text="orderAlertText"
          :alert-style="orderAlertStyle"
          :alert-icon="orderAlertIcon"
          alert-dismissable
          v-on:dismissalert="resetOrderAlerts"
          body-class="no-padding table-responsive"
        >
          <template v-if="hasOrders">
            <table class="datatable table table-striped primary dataTable no-footer">
              <thead>
                <tr>
                  <th>{{ $t('Orders.orderNum') }}</th>
                  <th>{{ $t('Common.date') }}</th>
                  <th>{{ $t('Common.status') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in orders">
                  <td>
                    <a v-on:click="openOrder(row.ID)">{{ row.transactionnum }}</a>
                  </td>
                  <td>{{ row.date | formatDate }}</td>
                  <td>
                    <order-status-badge :order="row"/>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="a-c pbottom-10">
              <button type="button" class="btn btn-info" v-on:click="showOrders"><i class="fa fa-inbox"></i> {{ $t('Orders.showAll') }}</button>
            </div>
          </template>
          <div class="empty-indicator" v-else>
            <i class="fa fa-inbox"></i> {{ $t('Orders.noOrders') }}
          </div>
        </card>
      </div>
      <div class="col-lg-6 col-md-12 col-xs-12">
        <card
          :title="$t('Projects.currentProjects')"
          :refresh="loadProjects"
          :loader="projectLoader"
          :alert="projectAlert"
          :alert-text="projectAlertText"
          :alert-style="projectAlertStyle"
          :alert-icon="projectAlertIcon"
          alert-dismissable
          v-on:dismissalert="resetProjectAlerts"
          body-class="no-padding table-responsive"
        >
          <template v-if="hasProjects">
            <table class="datatable table table-striped primary dataTable no-footer">
              <thead>
                <tr>
                  <th>{{ $t('Projects.projectName') }}</th>
                  <th>{{ $t('Common.lastmodified') }}</th>
                  <th>{{ $t('Common.status') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in projects">
                  <td>
                    <a v-on:click="openProject(row.ID)">{{ row.name }}</a>
                  </td>
                  <td>{{ row.lastmodified | formatDate }}</td>
                  <td>
                    <project-status-badge :status="row.status"/>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="a-c pbottom-10">
              <button type="button" class="btn btn-info" v-on:click="showProjects"><i class="fa fa-cog"></i> {{ $t('Projects.showAll') }}</button>
            </div>
          </template>
          <div class="empty-indicator" v-else>
            <i class="fa fa-cog"></i> {{ $t('Projects.noProjects') }}
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import ProjectStatusBadge from '../Elements/ProjectStatusBadge';
import OrderStatusBadge from '../Elements/OrderStatusBadge';
const view = require('../view.js'),
    viewData = {
      orderCount: 0,
      orders: [],
      orderLoader: '',
      orderAlert: '',
      orderAlertText: '',
      orderAlertStyle: '',
      orderAlertIcon: '',
      projectCount: 0,
      projects: [],
      projectLoader: '',
      projectAlert: '',
      projectAlertText: '',
      projectAlertStyle: '',
      projectAlertIcon: ''
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  components: {
    ProjectStatusBadge,
    OrderStatusBadge,
  },
  props: {

  },
  computed: {
    hasOrders() {
      return this.orders.length > 0;
    },
    hasProjects() {
      return this.projects.length > 0;
    }
  },
  mounted() {
    this.$parent.viewTitle = this.$t('Dashboard.title');
    this.reset();
  },
  methods: {
    reset() {
      for (var i in resetData) {
        if (resetData.hasOwnProperty(i)) {
          if (typeof resetData[i] != 'object') {
            viewData[i] = resetData[i];
          }
        }
      }

      this.loadOrders();
      this.loadProjects();
    },
    loadOrders() {
      viewData.orderLoader = this.$t('Orders.loading');
      this.$http.get(this.$root.url + 'order/', {params: {limit: 5}}).then(function(res) {
          viewData.orderLoader = '';
          viewData.orderCount = res.data.result.count;
          viewData.orders = res.data.result.data;
        }.bind(this),
        function(res) {
          viewData.orderLoader = '';
          viewData.orderAlertStyle = 'danger';
          viewData.orderAlert = this.$t('Orders.errorCouldNotLoad');
          if (typeof res.data.error != 'undefined') {
            viewData.orderAlertText = res.data.error;
          }
        }.bind(this));
    },
    openOrder(ID) {
      this.$parent.openView('OrderDetails', ID);
    },
    showOrders() {
      this.$parent.openView('Orders');
    },
    resetOrderAlerts() {
      this.orderAlert = '';
      this.orderAlertText = '';
      this.orderAlertStyle = '';
      this.orderAlertIcon = '';
    },
    loadProjects() {
      viewData.projectLoader = this.$t('Projects.loading');
      this.$http.get(this.$root.url + 'project/', {params: {limit: 5}}).then(function(res) {
          viewData.projectLoader = '';
          viewData.projectCount = res.data.result.count;
          viewData.projects = res.data.result.data;
        }.bind(this),
        function(res) {
          viewData.projectLoader = '';
          viewData.projectAlertStyle = 'danger';
          viewData.projectAlert = this.$t('Projects.errorCouldNotLoad');
          if (typeof res.data.error != 'undefined') {
            viewData.projectAlertText = res.data.error;
          }
        }.bind(this));
    },
    openProject(ID) {
      this.$parent.openView('ProjectDetails', ID);
    },
    showProjects() {
      this.$parent.openView('Projects');
    },
    resetProjectAlerts() {
      this.projectAlert = '';
      this.projectAlertText = '';
      this.projectAlertStyle = '';
      this.projectAlertIcon = '';
    },
    createProject() {
      this.$parent.$refs.newProject.openDialog();
    },
  }
});
</script>
